var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.toolbar }, [
    _c(
      "div",
      { class: _vm.$style.toolbar__left },
      [
        _vm.uiConfig.ui.includes("yearSwitch")
          ? _c("div", { class: _vm.$style.chart_toolbox }, [
              _c("div", { class: _vm.$style.year_switch }, [
                _c(
                  "div",
                  {
                    class: _vm.$style.previous,
                    on: {
                      click: function ($event) {
                        return _vm.setCurrent(-1)
                      },
                    },
                  },
                  [
                    _c("svg-sprite", {
                      attrs: {
                        type: "bold",
                        name: "arrow-left",
                        size: 24,
                        color:
                          _vm.toolbarYearSwitchData.minYear ===
                          _vm.toolbarYearSwitchData.currentYear
                            ? "#CCCCCC"
                            : "#808080",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { class: _vm.$style.current }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.toolbarYearSwitchData.currentYear) +
                      " " +
                      _vm._s(_vm.locales("year")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: _vm.$style.next,
                    on: {
                      click: function ($event) {
                        return _vm.setCurrent(1)
                      },
                    },
                  },
                  [
                    _c("svg-sprite", {
                      attrs: {
                        type: "bold",
                        name: "arrow-right",
                        size: 24,
                        color:
                          _vm.toolbarYearSwitchData.maxYear ===
                          _vm.toolbarYearSwitchData.currentYear
                            ? "#CCCCCC"
                            : "#808080",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.uiConfig.ui.includes("range") && _vm.rangeValue.length
          ? _c(
              "div",
              { class: [_vm.$style.range_value, _vm.$style.right_divider] },
              [_vm._v("\n      " + _vm._s(_vm.rangeValue) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.uiConfig.ui.includes("dropdown")
          ? _c("toolbar-dropdown", {
              attrs: { menu: _vm.dropMenu, disabled: _vm.toolbarDisabled },
              on: {
                onSelect: function (data) {
                  return _vm.$emit("onSelectDropdown", data)
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$style.toolbar__right },
      [
        _vm.uiConfig.ui.includes("filter") ? _c("filter-button") : _vm._e(),
        _vm._v(" "),
        _vm.uiConfig.ui.includes("export") && _vm.hasAccessToExport
          ? _c("tooltip", {
              class: _vm.$style.tooltip_wrapper,
              attrs: {
                content: _vm.tooltipContent,
                position: "bottom-end",
                interactive: true,
                "with-animation": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "body",
                    fn: function () {
                      return [
                        _c("vgp-icon-button", {
                          attrs: {
                            size: "small",
                            colors: _vm.buttonColors,
                            disabled: _vm.toolbarDisabled,
                            label: _vm.locales("common_export"),
                            icon: { name: "link-2", size: 20 },
                          },
                          on: { onClick: _vm.onClickExport },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                3248624662
              ),
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }